import { useQuery } from '@tanstack/react-query';
import type { AiInstructionContent } from '@/types/ai-instructions';
import { apiClient } from '@/lib/api-client';

export function useInstructionContent(
  organizationId: string,
  contentId: string | null
) {
  return useQuery<AiInstructionContent, Error>({
    queryKey: ['ai-instruction-content', organizationId, contentId],
    queryFn: async (): Promise<AiInstructionContent> => {
      if (!contentId) {
        throw new Error('Content ID is required');
      }

      const response = await apiClient.get(
        `/organizations/${organizationId}/ai-instructions/${contentId}/content`
      );

      return response as unknown as AiInstructionContent;
    },
    enabled: !!organizationId && !!contentId,
  });
}
